import { getSharedConfig } from "../../createSharedConfig"
import { getBuyRequestMeta, getSimpleForBuyRequest } from "@/js/helpers/buy-request"
import { RACK_COLORS } from "@/js/pages/product/rackbuilder/constants"
import { RackOptions } from "@/js/pages/product/rackbuilder/RackTypes"
import { findBundleProduct, getAccessoryQuantity } from "@/js/pages/product/rackbuilder/utils/product-lookup"
import { getCommonAccessorySelections, getDepthSelection, getFrontSelection, getPlateStorageSelection } from "@/js/pages/product/rackbuilder/utils/selection-utils"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"

export function createIndyAddonConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const meta = getBuyRequestMeta(buyRequest, rogue)
  const rack = findBundleProduct(rogue, buyRequest, 'rack') || getSimpleForBuyRequest(buyRequest, rogue)
  const functionalTrainer = findBundleProduct(rogue, buyRequest, 'trainer')

  const sharedConfig = getSharedConfig(rogue, buyRequest)
  const isHalfRack = rack?.attributes?.rack_size === '4'
  const is80Height = sharedConfig.height === '80'

  const leftSide = functionalTrainer?.attributes.side === 'Left' || functionalTrainer?.attributes.side === 'Dual'
  const rightSide = functionalTrainer?.attributes.side === 'Right' || functionalTrainer?.attributes.side === 'Dual'

  const { trolleySelection } = getCommonAccessorySelections(rogue, buyRequest, sharedConfig.materials || {})

  return {
    ...sharedConfig,
    back            : is80Height ? 'crossmember top 4' : 'nameplate',
    front           : is80Height ? 'offset' : getFrontSelection(rogue, buyRequest, meta),
    edition         : 'indy',
    color           : RACK_COLORS['Rogue Red'],
    jcup            : '',
    depth           : getDepthSelection(rack, meta),
    halfRack        : isHalfRack || undefined,
    sixPost         : !isHalfRack,
    plateStorage    : getPlateStorageSelection(rogue, buyRequest),
    storagePosts    : false,
    ghostRack       : false,
    ftShrouds       : rack?.attributes.rig_or_wm !== 'No',
    spotterArms     : getAccessoryQuantity(rogue, buyRequest, 'safety spotter'),
    frontStabilizer : Boolean(findBundleProduct(rogue, buyRequest, 'half rack feet', true)),
    addIndy         : true,
    leftSide,
    rightSide,
    trolleySelection,
    isAddon         : true,
  }
}
